import { Action, ActionReducer, createReducer, on } from '@ngrx/store';

import { EventsActions } from './events.actions';
import { EventsState } from './events.state';

export const initEventsState: EventsState = {
  events: [],
  cursor: undefined,
  loading: false,
  loaded: false,
  error: null,
  filters: [],
  dateFilter: undefined,
  cachedUsers: [],
  cachedUsersIds: [],
  downloadGeneration: {
    loading: false,
    error: null,
  },
};

export const eventsReducer: ActionReducer<EventsState, Action> = createReducer(
  initEventsState,

  on(
    EventsActions.loadEvents,
    (state): EventsState => ({
      ...state,
      loading: true,
      loaded: false,
      error: null,
    })
  ),

  on(
    EventsActions.loadEventsSuccess,
    (state, { eventsList, cursor }): EventsState => ({
      ...state,
      loading: false,
      loaded: true,
      events: [...state.events, ...eventsList],
      cursor,
    })
  ),

  on(
    EventsActions.loadEventsError,
    (state): EventsState => ({
      ...state,
      loading: false,
      loaded: true,
      error: {},
    })
  ),

  on(
    EventsActions.updateFilters,
    (state, { filters, dateFilter }): EventsState => ({
      ...state,
      cursor: undefined,
      events: [],
      filters,
      dateFilter,
    })
  ),

  on(
    EventsActions.resetEvents,
    (): EventsState => ({
      ...initEventsState,
    })
  ),

  on(
    EventsActions.loadUserDetails,
    (state, { uuid }): EventsState => ({
      ...state,
      cachedUsersIds: [...state.cachedUsersIds, uuid],
    })
  ),

  on(
    EventsActions.loadUserDetailsSuccess,
    (state, { userDetails }): EventsState => ({
      ...state,
      cachedUsers: [...state.cachedUsers, userDetails],
    })
  ),

  on(
    EventsActions.triggerEventLogFileGeneration.cleanup,
    (state): EventsState => ({
      ...state,
      downloadGeneration: structuredClone(initEventsState.downloadGeneration),
    })
  ),

  on(
    EventsActions.triggerEventLogFileGeneration.attempt,
    (state): EventsState => ({
      ...state,
      downloadGeneration: {
        loading: true,
        error: null,
      },
    })
  ),

  on(
    EventsActions.triggerEventLogFileGeneration.error,
    (state, { error }): EventsState => ({
      ...state,
      downloadGeneration: {
        ...state.downloadGeneration,
        loading: false,
        error,
      },
    })
  ),

  on(
    EventsActions.triggerEventLogFileGeneration.success,
    (state): EventsState => ({
      ...state,
      downloadGeneration: {
        ...state.downloadGeneration,
      },
    })
  ),

  on(
    EventsActions.downloadEventLogFile.success,
    (state): EventsState => ({
      ...state,
      downloadGeneration: {
        ...state.downloadGeneration,
        loading: false,
      },
    })
  ),

  on(
    EventsActions.downloadEventLogFile.error,
    (state, { error }): EventsState => ({
      ...state,
      downloadGeneration: {
        ...state.downloadGeneration,
        loading: false,
        error,
      },
    })
  )
);
